import React from "react";

export const EmailLabel = ({ index }) => {
  return (
    <span>
      Email <sup>{index + 1}</sup>
    </span>
  );
};
